//Core Prod

// Alshifa Settings
// export const environment = {
//   version: 'https://o3-ms-core-app.azurewebsites.net/assets/js/version.json',
//   production: true,
//   O3CoreApiUrl: 'https://o3-ms-gateway-api.azurewebsites.net/api/',
//   ImageUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   O3ImageUrl: 'https://o3-live-net-app.azurewebsites.net/',
//   NotificationUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
//   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
//   companyKey: '03182ffc-c62e-44e6-9004-ae70599a2959', //o3 manufacturing
//   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
//   api_version: 'v1.0.0',
//   white_listed_Domains: [
//     'https://o3-ms-gateway-api.azurewebsites.net/'
//   ],
//   api_baseurl: 'https://o3-ms-gateway-api.azurewebsites.net/',
//   api_signalR_baseUrl: 'https://o3-ms-auth-api.azurewebsites.net/',
//   api_prefix: 'api/',
//   lean_app_url: 'https://o3-ms-lean-app.azurewebsites.net/login',
//   firebaseConfig: {
//     apiKey: "AIzaSyBqxBUm4LxEB7elXcHOJWL-yxDB96C-L4Q",
//     authDomain: "obeikan-3f195.firebaseapp.com",
//     projectId: "obeikan-3f195",
//     storageBucket: "obeikan-3f195.appspot.com",
//     messagingSenderId: "634961850948",
//     appId: "1:634961850948:web:f6553a43e7a661a2db4211",
//     measurementId: "G-P6JPX793G7"
//   },
//   fireBaseAuthKey: 'AAAAk9as8kQ:APA91bGilHLjMECZCyZULiS8mJ-wlzRqGdRW9r17Cm7YbVMqbnX4hSkEoVvuoITFmQxB5N9qNY3-CJGCYD_OGG5QEDmLyOfwHYjjd9SeZhaWfBCvF7uZ2ZaZCsVKvtCnHyUQVJQsinEx'
// };

// SIG
// export const environment = {
//   version: 'https://live.o3manufacturing.com/assets/js/version.json',
//   production: true,
//   O3CoreApiUrl: ''https://localhost:8051/api/',',
//   ApiUrl: 'https://o3-live-node-api.o3manufacturing.com:90/api/',
//   ImageUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   O3ImageUrl: 'https://o3-live-net-app.azurewebsites.net/',
//   NotificationUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
//   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
//   companyKey: '03182ffc-c62e-44e6-9004-ae70599a2959', //o3 manufacturing
//   api_version: 'v1.0.0',
//   white_listed_Domains: [
//     'https://o3-cloud-gateway-api.azurewebsites.net/'
//   ],
//   api_baseurl: 'https://o3-cloud-gateway-api.azurewebsites.net/',
//   api_signalR_baseUrl: 'https://o3-live-auth-api.azurewebsites.net/',
//   api_baseurlUty: ''https://localhost:8051/api/',',
//   api_prefix: 'api/',
//   lean_app_url: 'https://siglean.o3manufacturing.com/login',
//   firebaseConfig: {
//     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
//     authDomain: "o3-push-notification.firebaseapp.com",
//     projectId: "o3-push-notification",
//     storageBucket: "o3-push-notification.appspot.com",
//     messagingSenderId: "372705983827",
//     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
//     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
//   }
// }

//-------------------Live

// export const environment = {
//   version: 'https://live.o3manufacturing.com/assets/js/version.json',
//   production: true,
//   O3CoreApiUrl: 'https://localhost:8051/api/',
//   ApiUrl: 'https://o3-live-node-api.o3manufacturing.com:90/api/',
//   ImageUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   O3ImageUrl: 'https://o3-live-net-app.azurewebsites.net/',
//   NotificationUrl: 'https://o3-live-node-api.o3manufacturing.com:90/',
//   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
//   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
//   companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
//   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
//   api_version: 'v1.0.0',
//   white_listed_Domains: [
//     'https://localhost:8051/'
//   ],
//   api_baseurl: 'https://localhost:8051/',
//   api_signalR_baseUrl: 'https://o3-live-auth-api.azurewebsites.net/',
//   api_baseurlUty: 'https://localhost:8051/api/',
//   api_prefix: 'api/',
//   lean_app_url: 'https://o3-cloud-lean-angular.azurewebsites.net/login',
//   firebaseConfig: {
//     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
//     authDomain: "o3-push-notification.firebaseapp.com",
//     projectId: "o3-push-notification",
//     storageBucket: "o3-push-notification.appspot.com",
//     messagingSenderId: "372705983827",
//     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
//     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
//   }
// }
export const environment = {
  version: 'http://localhost:4200/assets/js/version.json',
  production: true,
   O3CoreApiUrl: 'https://localhost:8051/api/',
  //O3CoreApiUrl: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
  workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
  blobStorageUrl:
    'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
  companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
  LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
  api_version: 'v1.0.0',
  white_listed_Domains: ['https://localhost:8051/'],
  api_signalR_baseUrl: 'https://localhost:8054/',
  api_prefix: 'api/',
  lean_app_url: 'http://localhost:51376/', //https://o3-cloud-lean-angular.azurewebsites.net
  uiBuilder_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
  utility_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
  firebaseConfig: {
    apiKey: 'AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4',
    authDomain: 'o3-push-notification.firebaseapp.com',
    projectId: 'o3-push-notification',
    storageBucket: 'o3-push-notification.appspot.com',
    messagingSenderId: '372705983827',
    appId: '1:372705983827:web:ce7c5df94e807d28ee35a6',
    vapidKey:
      'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI',
  },
};

// // // // export const environment = {
// // // //   version: 'https://o3-cloud-core-angular.azurewebsites.net/assets/js/version.json',
// // // //   production: false,
// // // //   O3CoreApiUrl: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
// // // //   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
// // // //   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
// // // //   companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
// // // //   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
// // // //   api_version: 'v1.0.0',
// // // //   white_listed_Domains: [
// // // //     'https://o3-cloud-gateway-api.azurewebsites.net/'
// // // //   ],
// // // //   api_baseurl: 'https://o3-cloud-gateway-api.azurewebsites.net/',
// // // //   api_signalR_baseUrl: 'https://o3-cloud-auth-api.azurewebsites.net/',
// // // //   api_prefix: 'api/',
// // // //   lean_app_url: 'https://uatlean.o3ai.com/login',
// // // //   uiBuilder_app_url: 'https://uat-ui-builder.o3ai.com/login',
// // // //   utility_app_url: 'https://o3-cloud-saned-angular.azurewebsites.net/login',
// // // //   firebaseConfig: {
// // // //     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
// // // //     authDomain: "o3-push-notification.firebaseapp.com",
// // // //     projectId: "o3-push-notification",
// // // //     storageBucket: "o3-push-notification.appspot.com",
// // // //     messagingSenderId: "372705983827",
// // // //     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
// // // //     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
// // // //   }
// // // // }

// // export const environment = {
// //   version: 'https://o3-cloud-core-angular.azurewebsites.net/assets/js/version.json',
// //   production: false,
// //   O3CoreApiUrl: 'https://o3-cloud-gateway-api.azurewebsites.net/api/',
// //   workFLowApi: 'https://o3-uat-workflowengine-new.azurewebsites.net/api/',
// //   blobStorageUrl: 'https://o3storagenew.blob.core.windows.net/o3-live-attachments/',
// //   companyKey: '13182ffc-c62e-44e6-8004-ae70599a2959', //o3 manufacturing
// //   LLMRequestUrl: 'https://o3chatbot.azurewebsites.net/api/o3Chatbot',
// //   api_version: 'v1.0.0',
// //   white_listed_Domains: [
// //     'https://o3-cloud-gateway-api.azurewebsites.net/'
// //   ],
// //   api_baseurl: 'https://o3-cloud-gateway-api.azurewebsites.net/',
// //   api_signalR_baseUrl: 'https://o3-live-auth-api.azurewebsites.net/',
// //   api_prefix: 'api/',
// //   lean_app_url: 'https://o3-cloud-lean-angular.azurewebsites.net/login',
// //   uiBuilder_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
// //   utility_app_url: 'https://o3-stage-formbuilder.azurewebsites.net/login',
// //   firebaseConfig: {
// //     apiKey: "AIzaSyCkw0AR6W9SlW38pxJw84V_gfC1-l028J4",
// //     authDomain: "o3-push-notification.firebaseapp.com",
// //     projectId: "o3-push-notification",
// //     storageBucket: "o3-push-notification.appspot.com",
// //     messagingSenderId: "372705983827",
// //     appId: "1:372705983827:web:ce7c5df94e807d28ee35a6",
// //     vapidKey: 'BCG-sawfa3_DaGjQ0ZbCm8NNWlS7L90qNuLIdCx8Z7lxdjOL9roOkJdrYkfQ4F3PtokU26vlXuneSpYMng6RhJI'
// //   }
// // }
